import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ loading }) => {
  const [shouldRender, setShouldRender] = useState(true);

  useEffect(() => {
    let timer;
    if (!loading) {
      const loadingScreen = document.querySelector('.loading-container');
      if (loadingScreen) {
        loadingScreen.classList.add('fade-out');
        // Faster transition for a more responsive feel
        timer = setTimeout(() => {
          setShouldRender(false);
        }, 500);
      }
    } else {
      setShouldRender(true);
    }
    return () => clearTimeout(timer);
  }, [loading]);

  if (!shouldRender) return null;

  return (
    <div className="loading-container">
      <div className="loading-logo">m🙂jie</div>
      <div className="loading-text">Loading daily puzzles</div>
    </div>
  );
};

export default LoadingScreen;

